<template>
  <div class="link-page">
    <header-pane
      class="link-page__header"
      colorType="light"
      :pageTitle="$tc('LinkPage.pageTitle')"
    />

    <link-pane />

    <global-navigation-pane current="link" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import LinkPane from '@/components/LinkPage/LinkPane.vue'

/**
 * LINK ページ
 */
export default defineComponent({
  name: 'LinkPage',
  components: {
    HeaderPane,
    GlobalNavigationPane,
    LinkPane,
  },
})
</script>

<style lang="scss" scoped>
.link-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
